import { SOURCE_RUNTIME_TO_REPOSITORY, UNKNOWN_REPOSITORY } from '@/core/const/installation.const'
import { Runtime } from '@/core/enums/runtime.enum'

import {
  buildComposerPublishId,
  buildHyphenatedFeedPublishId,
  buildNpmPublishId,
  buildNugetPublishId,
} from './matrixPublishId'
import { normalizeNameForNamespace } from './normalizeNameForNamespace'
import { pascalCaseFull } from './pascalCaseFull'

export const getSourceRepository = (runtime?: Runtime): string =>
  runtime ? (SOURCE_RUNTIME_TO_REPOSITORY[runtime] ?? UNKNOWN_REPOSITORY) : UNKNOWN_REPOSITORY

export const buildPackageNamespace = (
  consumerTechnology: string,
  repository: string,
  libraryName: string,
  normalizedLibraryName: string
): string => {
  if (consumerTechnology === 'ruby') return `graft.${repository}.${libraryName}`
  return `graft.${repository}.${normalizedLibraryName}`
}

export const buildGraftName = (
  consumerTechnology: string,
  repository: string,
  libraryName: string,
  packageNamespace: string,
  libraryNamespace?: string
): string => {
  if (consumerTechnology === 'npm') {
    return buildNpmPublishId(repository, libraryNamespace, libraryName)
  }

  if (consumerTechnology === 'packagist') {
    return `graft-${repository}-${libraryName}`
  }

  if (consumerTechnology === 'ruby') {
    return `graft.${repository}.${libraryName}`
  }

  return packageNamespace
}

export const buildMavenGroupId = (libraryNamespace?: string): string => {
  const trimmed = libraryNamespace?.trim()
  if (!trimmed) return 'graft.maven'
  return `graft.maven.${normalizeNameForNamespace(trimmed)}`
}

export const buildPhpNamespace = (repository: string, libraryName: string): string =>
  `Graft\\${pascalCaseFull(repository)}\\${pascalCaseFull(libraryName)}`

export const buildRubyRequirePath = (repository: string, libraryName: string): string =>
  `graft.${repository}.${libraryName}`.replace(/[.-]/g, '_')

export const buildPublishId = (
  consumerTechnology: string,
  repository: string,
  libraryName: string,
  libraryNamespace: string | undefined,
  packageNamespace: string,
  normalizedLibraryName: string
): string => {
  switch (consumerTechnology) {
    case 'npm':
      return buildNpmPublishId(repository, libraryNamespace, libraryName)
    case 'pypi':
      return buildHyphenatedFeedPublishId(repository, libraryNamespace, libraryName)
    case 'packagist':
      return buildComposerPublishId(repository, libraryNamespace, libraryName)
    case 'ruby':
      return buildHyphenatedFeedPublishId(repository, libraryNamespace, libraryName)
    case 'nuget':
      return buildNugetPublishId(repository, libraryNamespace, libraryName, normalizedLibraryName)
    case 'maven':
    default:
      return packageNamespace
  }
}
